import React, { useEffect,useRef, useState } from 'react';
import "./BookList.css";
import { useNavigate } from 'react-router-dom';
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import { jwtDecode } from "jwt-decode";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { api } from '../../config';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const BookForm = () => {

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        first_publish_year: '',
        cover_image: '',
        book_url: '',
        type: '',
        category: '',
        author: [],
        related_book: '',
        order: '',
      });
      
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();
    const [authors , setAuthors] = useState([]);
    const [related_books , setRelated_books] = useState([]);
    const [showNewAuthorForm, setShowNewAuthorForm] = useState(false); // State to toggle new author form
    const [showNewCategoryForm, setShowNewCategoryForm] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const currentYear = new Date().getFullYear();
    const startYear = 1900;
    const years = Array.from(new Array(currentYear - startYear + 1), (val, index) => startYear + index);
    years.reverse();
        // Define your toolbar options including text alignment
    const modules = {
        toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
    
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction
    
        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],
        
    
        ['clean']     ,

        // remove formatting button
        ],
    };
    
    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
        'list', 'bullet', 'indent',
        'link', 'image', 'video',
        'align', 'direction', 'color', 'background'
    ];
    

  const getAuthors = async () => {
    try {
      const response = await fetch(`${api}/book_author/authors`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });
       let data = await response.json();
        //console.log(data);
        setAuthors(data);
        
      }
     
     catch (error) {
      //console.log(error);
    }
  }

const getRelatedBooks = async () => {
  try {
    const response = await fetch(`${api}/book_author/related_books`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
     let data = await response.json();
      //console.log(data);
      setRelated_books(data);
    }
   
   catch (error) {
    //console.log(error);
  }
}
  const handleChange = (e) => {
    const token = localStorage.getItem('token');
    //console.log("token");
    //console.log(token);
    let decodedToken ='';
    if (token) {
       decodedToken = (token);
    }

    setFormData({ ...formData, [e.target.name]: e.target.value,token: decodedToken});
  };


const handleChangedes = (value) => {
  const token = localStorage.getItem('token');
  //console.log("token");
  //console.log(token);
  let decodedToken ='';
  if (token) {
     decodedToken = (token);
  }

  setFormData({ ...formData, description:value,token: decodedToken});
};

function validateForm(formData) {
  let isValid = true;
  const errors = {};

  // التحقق من العنوان
  if (!formData.title.trim()) {
      errors.title = "العنوان مطلوب.";
      isValid = false;
  }


  if (!formData.cover_image.trim()) {
    // Handle invalid URL format (e.g., display an error message)
    errors.cover_image = "رابط صورة الغلاف مطلوب.";
    isValid = false; 
}else{
  const urlPattern = /^(https?:\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
  if (!urlPattern.test(formData.cover_image.trim())) {

    errors.cover_image = "الرجاء التحقق من رابط صورة الغلاف .";
    isValid = false;

  }
}

// التحقق من رابط المحتوى (اختياري إذا كان مطلوبًا)

if (!formData.book_url.trim()) {
  // Handle invalid URL format (e.g., display an error message)
  errors.book_url = "رابط المحتوى مطلوب.";
  isValid = false; 
}else{
const urlPattern = /^(https?:\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
if (!urlPattern.test(formData.book_url.trim())) {

  errors.book_url = "الرجاء التحقق من رابط المحتوى  .";
  isValid = false;

}
}
  // التحقق من وصف باستخدام دالة التحقق من النص الغني


  // التحقق من المؤلف (التحقق من تحديد مؤلف واحد على الأقل)
  if (!formData.author.length) {
      errors.author = "يجب تحديد مؤلف واحد على الأقل.";
      isValid = false;
  }

  // التحقق من سنة النشر
  if (!formData.first_publish_year.trim()) {
      errors.first_publish_year = "سنة النشر مطلوبة.";
      isValid = false;
  }

  // التحقق من النوع
  if (!formData.type.trim()) {
      errors.type = "نوع النشر مطلوب.";
      isValid = false;
  }

  // التحقق من المجلة للمجلات
  if (formData.type === 'journal' && !formData.category) {
      errors.category = "المجلة مطلوبة للاعداد.";
      isValid = false;
  }

  return { isValid, errors };
}

function isEmptyRichText(value) {
  // Remove HTML tags and trim the remaining text
  try{
      const textOnly = value.replace(/<[^>]*>/g, '').trim();
  return textOnly === '';
  }catch{
    return false;
  }
}
   const handleSubmit = async (e) => {
    e.preventDefault();
    const { isValid, errors } = validateForm(formData);

    if (!isValid) {
      Object.values(errors).forEach(error => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    }); // Here you could set these errors to state and display them in the form
        return;
    }

    formData.category = formData.category || 0 ;
    if (isEmptyRichText(formData.description)) {
      formData.description = null;
  }
    const token = localStorage.getItem('token');
    if (!token) {
        // Handle the case when token is null (e.g., redirect to login page)
        //console.log('User is not authenticated. Redirecting to home page...');
        window.location.href = '/index';
        // Redirect logic or display unauthorized message
        return;
    }
    let decodedToken ='';
    if (token) {
       decodedToken = (token);
    }
    try {
        const response = await fetch(`${api}/book_author/newBook`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${decodedToken}` // Include token in request header
            },
          body: JSON.stringify(formData),
        });
       let data = await response.json();
        //console.log(data);

        if (data.message ==="Book created successfully") {
          //console.log("      <ToastContainer />");
          toast.success('تمت الإضافة  بنجاح');
          // navigate('/book');
        }else if(data.error === "Missing required fields") {
          //console.log("      <ToastContainer />");
          toast.warning('الرجاء اكمال جميع البيانات');
          // navigate('/book');
        }else{
          toast.error('حدث خطأ، الرجاء المحاولة مره اخرى');
          // navigate('/book');
        }
        setShowForm(false);

      }
     
     catch (error) {
      //console.log(error);
      setShowForm(false);

      navigate('/book');
      
    }
    

  };

    // Function to handle adding a new author
    const handleAddNewAuthor = async () => {
      setShowNewAuthorForm(true);
    }
    const handleAddCategory = async () => {
      setShowNewCategoryForm(true);
    }

    useEffect(() => {
    if (!showForm) return;
      getAuthors();
      getCategories();
      getRelatedBooks();
    }, [showForm]);

  
  
    // Function to handle submitting the new author form
    const handleSubmitNewAuthor = async (e) => {
      e.preventDefault();
      
      const token = localStorage.getItem('token');
      if (!token) {
          // Handle the case when token is null (e.g., redirect to login page)
          //console.log('User is not authenticated. Redirecting to home page...');
          window.location.href = '/index';
          // Redirect logic or display unauthorized message
          return;
      }
      let decodedToken ='';
      if (token) {
         decodedToken = (token);
      }
      try {
        const response = await fetch(`${api}/book_author/newAuthor`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${decodedToken}` 
            },
            body: JSON.stringify({
              name: formData.author_name,

              token:decodedToken,
            }
            ),
          });
         let data = await response.json();
         
         //console.log(data);
         if (data.message === "Author created successfully") {
          //console.log("      <ToastContainer />");
          toast.success('تم إضافة المؤلف بنجاح');
          setAuthors(prevAuthors => [...prevAuthors]);

        }if (data.error === "Missing required fields") {
            toast.warning('الرجاء إدخال  أسم');
        }if (data.error === "This name is already taken") {
            toast.error('الاسم موجود مسبقا');
        }
       
          //console.log(data);
        }
       
       catch (error) {
        //console.log(error);
      }
      
      setShowNewAuthorForm(false); 
      getAuthors();
      
    }
  

    const checkTokenExpiration = () => {
        const token = localStorage.getItem('token');
        //console.log("token");
        //console.log(token);
        if (token) {
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
          //console.log("decodedToken");
          //console.log(decodedToken);
          if (decodedToken.exp < currentTime) {
            // Token has expired, clear it from local storage
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('username');
          }
        }else{
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('username');
        }
        const username = localStorage.getItem('username');
        setIsLoggedIn(!!username); // Check if username exists in localStorage
        
      };
    
      useEffect(() => {
        const username = localStorage.getItem('username');
        setIsLoggedIn(!!username); // Check if username exists in localStorage
        checkTokenExpiration();
      }, []);
    
      const getCategories = async () => {
        try {
            const response = await fetch(`${api}/book_author/category`, { method: 'GET' });
            const data = await response.json();
            setCategories(data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };
    

return (
  <>
  <span>
    {showForm ? (
            
        <form className='book-details-form' onSubmit={handleSubmit}>
           
           <div className='book-details-form-item'>
             <label>النوع: <span style={{ color: 'red' }}>*</span></label>
             <select name="type" style={{width:"100%",height:"40px"}} value={formData.type} onChange={handleChange} required>
                <option value="">اختر...</option>
                <option value="book">كتاب</option>
                <option value="journal">مجلة</option>
             </select>
           </div>
           {formData.type === 'book' && (
            <>
                <div className='book-details-form-item'>
                <label> الجزء السابق:</label>
                <Autocomplete
               id="book_id"
               options={related_books}
               getOptionLabel={(option) => option.title}
               onChange={(e, newValue) => setFormData({...formData, related_book: newValue})}
               renderInput={(params) => <TextField {...params} />}
               
             />
   
              </div>
              { formData.related_book && ( 
              <div className='book-details-form-item'>
                <label>رقم الجزء (الحالي): <span style={{ color: 'red' }}>*</span></label>
                <input type='number' name='order' value={formData.order} onChange={handleChange} required={!!formData.related_book}/>
              </div>
              )}
            </>
           )}
           
          { formData.type === 'journal' && ( 
  
  <div className='book-details-form-item'>

    <label>المجلة <span style={{ color: 'red' }}>*</span></label>
    <select name="category"style={{width:"100%",height:"40px"}}  value={formData.category} onChange={handleChange}>
       <option value="">اختر...</option>
       {categories.map((category) => {
         if (category.category_id === 0) {
           return null; // Skip rendering this option
         }
         return (
           <option key={category.category_id} value={category.category_id}>
             {category.category_name}
           </option>
         );
       })}

    </select>
   <div className='form-buttons'>
                   </div>
                 </div>
                 
                 )}
           <div className='book-details-form-item'>
             <label>عنوان <span style={{ color: 'red' }}>*</span>  </label>
             <input type='text' name='title' value={formData.title} onChange={handleChange} required />
           </div>
           <div className='book-details-form-item'>
             <label>وصف : </label>
             <ReactQuill
             style={{
             borderRadius: "7px",
             border: "1px solid"
    }}
            theme="snow"
            value={formData.description}
            onChange={handleChangedes}
            modules={modules}
            formats={formats}
          />
           </div>
           <div className='book-details-form-item'>
             <label> رابط الغلاف <span style={{ color: 'red' }}>*</span> </label>
             <input type='text' name='cover_image' value={formData.cover_image} onChange={handleChange} required/>
           </div>
           <div className='book-details-form-item'>
             <label>رابط المحتوى <span style={{ color: 'red' }}>*</span>  </label>
             <input type='text' name='book_url' value={formData.book_url} onChange={handleChange} required/>
           </div>
           <div className='book-details-form-item'>
             <label>تأليف <span style={{ color: 'red' }}>*</span> </label>
             <Autocomplete
             required   
            multiple
            id="author_id"
            options={authors}
            value={formData.author}
            getOptionLabel={(option) => option.author_name}
            onChange={(e, newValue) => setFormData({...formData, author: newValue})}
            renderInput={(params) => <TextField {...params} />}
          />

           </div>
           <div className='form-buttons'>
           {!showNewAuthorForm && (
               <button type='button' onClick={handleAddNewAuthor}>إضافة مؤلف جديد</button>
             )}
           </div>
           {showNewAuthorForm && (
             <>
               <div className='book-details-form-item'>
                 <label>اسم الكاتب <span style={{ color: 'red' }}>*</span> </label>
                 <input type='text' name='author_name' value={formData.author_name} onChange={handleChange} />
               </div>
            
               <div className='form-buttons'>
                 <button onClick={handleSubmitNewAuthor}> إضافة المؤلف</button>
                 <button onClick={() => setShowNewAuthorForm(false)}>الغاء</button>
               </div>
             </>
           )}
          
       
          <div className='book-details-form-item'>
            <label> سنة النشر <span style={{ color: 'red' }}>*</span></label>
            <select
              name='first_publish_year'
              value={formData.first_publish_year}
              onChange={handleChange}
              required  // if the field is mandatory
            >
              <option value="">اختر سنة</option>
              {years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>

           <div className='form-buttons'>
             <button type='submit'> إضافة </button>
             <button type='button' onClick={()=> setShowForm(false)}>إلغاء</button>
           </div>
         </form> 
        ) : (
           
            <button className="new-book-btn" onClick={() => setShowForm(true)}> إضافة إصدار  </button>
          
        )}
</span>
    </>
    )
}

export default BookForm;
